import { solidWhite, white70, blueGray, blueGray54, shark, redApple, scienceBlue } from '../theme/colors';

export default {
  errorStyle: {
    color: redApple
  },
  textStyle: {
    fontWeight: 300,
    letterSpacing: '.035em'
  },
  buttonStyle: {
    height: '48px',
    borderRadius: '4px'
  },
  buttonBorderStyle: {
    borderRadius: null
  },
  buttonLabelStyle: {
    lineHeight: '48px',
    letterSpacing: '.05em',
    fontWeight: '600'
  },
  labelStyle: {
    fontSize: '1.12rem',
    letterSpacing: '.035em',
    lineHeight: '45px',
    color: solidWhite
  },
  toggleLabelStyle: {
    fontSize: '1.2rem',
    color: white70,
    lineHeight: '2'
  },
  selectLabelStyle: {
    width: '100%',
    padding: '0px',
    color: blueGray,
    fontWeight: 600,
    textAlign: 'center'
  },
  selectMenuStyle: {
    color: scienceBlue
  },
  selectHintStyle: {
    textAlign: 'center',
    color: blueGray54,
    width: '100%',
    fontSize: '1.6rem',
    lineHeight: '18px',
    letterSpacing: '.024em'
  },
  modalLabelStyle: {
    fontSize: '1.4rem',
    fontWeight: 600,
    letterSpacing: '.035em'
  },
  modalTitleStyle: {
    paddingBottom: 0,
    fontSize: '2rem',
    fontWeight: 600,
    color: shark,
    letterSpacing: '.004em',
    lineHeight: '1.2'
  },
  dialogLabelStyle: {
    fontSize: '1.4rem',
    fontWeight: 600,
    color: scienceBlue,
    letterSpacing: '.05em',
    float: 'right'
  },
  floatingTextFieldStyle: {
    color: blueGray54
  },
  bottomSheetBody: {
    padding: '0 52px',
  }
};
